// extracted by mini-css-extract-plugin
export var readingIndicator = "reading-indicator-module--readingIndicator--3oDcw";